import { Component, Input, OnInit } from '@angular/core';
import { AdStatsBridgeAdUnitsService } from '../../../shared/services/ad-stats-bridge-ad-units.service';
import { BridgeAdUnit } from '../../../shared/domain/bridge-ad-unit.model';
import { SnackBarService } from '../../../shared/services/snackbar.service';
import { ServerErrorUtils } from '../../../shared/utils/server-error-utils';

@Component({
  selector: 'cm-ad-unit-flag',
  template: `
    <i class="fas fa-flag link" matTooltip="Unflag this unit" *ngIf="adUnit.flag" (click)="toggleFlag()"></i>
    <i class="far fa-flag link" matTooltip="Flag this unit" *ngIf="!adUnit.flag" (click)="toggleFlag()"></i>
  `,
})
export class AdUnitFlagComponent implements OnInit {

  @Input()
  adUnit: BridgeAdUnit;

  loading: boolean;

  constructor(private service: AdStatsBridgeAdUnitsService, private sbs: SnackBarService) {
  }

  ngOnInit(): void {
  }

  toggleFlag() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    this.service.changeFlag(this.adUnit.id, !this.adUnit.flag).subscribe(next => {
      this.adUnit.flag = next.flag;
      this.loading = false;
      this.sbs.success('Unit flag changed successfully');
    }, (e) => {
      this.loading = false;
      ServerErrorUtils.serverValidationOrMsg(e, this.sbs, 'Flag update failed');
    });
  }

}
